import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=40b4487e&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=ts&"
export * from "./CommonButton.vue?vue&type=script&lang=ts&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=40b4487e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4487e",
  null
  
)

export default component.exports